// import * as React from "react";
// import { styled, useTheme } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import MuiDrawer from "@mui/material/Drawer";
// import MuiAppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import List from "@mui/material/List";
// import CssBaseline from "@mui/material/CssBaseline";
// import Typography from "@mui/material/Typography";
// import Divider from "@mui/material/Divider";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import InboxIcon from "@mui/icons-material/MoveToInbox";
// import MailIcon from "@mui/icons-material/Mail";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import GroupsIcon from "@mui/icons-material/Groups";
// import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
// import FaceIcon from "@mui/icons-material/Face";
// import CallEndIcon from "@mui/icons-material/CallEnd";
// import Contacttablog from "../../Assets/img/logo2.png";
// import { Link, Outlet } from "react-router-dom";
// import { Helmet } from "react-helmet";

// const drawerWidth = 240;

// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: 'calc(${theme.spacing(7)} + 1px)',
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });
// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   // necessary for content to be below app bar
//   ...theme.mixins.toolbar,
// }));

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: 'calc(100% - ${drawerWidth}px)',
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

// export default function Sidenav() {
//   const theme = useTheme();
//   const [open, setOpen] = React.useState(true);
//   const [companyOpen, setCompanyOpen] = React.useState(false);
//   const [clientOpen, setClientOpen] = React.useState(false); // State for Client sub-menu
//   const [userOpen, setUserOpen] = React.useState(false); // State for User sub-menu
//   const [leadOpen, setLeadOpen] = React.useState(false); // State for Leads sub-menu
//   const [pitchedOpen, setPitchedOpen] = React.useState(false);
//   const [demoOpen, setDemoOpen] = React.useState(false);
//   const [negotiationsOpen, setNegotiationsOpen] = React.useState(false);
//   const [closedLostOpen, setClosedLostOpen] = React.useState(false);
//   const [closedWonOpen, setClosedWonOpen] = React.useState(false);
//   const [rnrOpen, setRnROpen] = React.useState(false);
//   const [junkOpen, setJunkOpen] = React.useState(false);

//   const handleDrawerOpen = () => {
//     setOpen(true);
//   };

//   const handleDrawerClose = () => {
//     setOpen(false);
//   };

//   const closeAllSubMenus = () => {
//     setClientOpen(false);
//     setUserOpen(false);
//     setLeadOpen(false);
//     setCompanyOpen(false);
//     setPitchedOpen(false);
//     // Closing the Leads sub-menu
//     // Add more logic here if more sub-menus are present
//   };

//   const handleClientClick = () => {
//     setClientOpen(!clientOpen);

//     if (companyOpen) {
//       setCompanyOpen(false);
//     }
//     if (userOpen) {
//       setUserOpen(false);
//     }
//     if (leadOpen) {
//       setLeadOpen(false);
//     }
//     if (pitchedOpen) {
//       setPitchedOpen(false);
//     }
//   };

//   const handleUserClick = () => {
//     setUserOpen(!userOpen);
//     if (companyOpen) {
//       setCompanyOpen(false);
//     }
//     if (clientOpen) {
//       setClientOpen(false);
//     }
//     if (leadOpen) {
//       setLeadOpen(false);
//     }
//     if (pitchedOpen) {
//       setPitchedOpen(false);
//     }
//   };

//   const handleLeadClick = () => {
//     setLeadOpen(!leadOpen);

//     if (companyOpen) {
//       setCompanyOpen(false);
//     }
//     if (clientOpen) {
//       setClientOpen(false);
//     }
//     if (userOpen) {
//       setUserOpen(false);
//     }
//     if (pitchedOpen) {
//       setPitchedOpen(false);
//     }
//   };

//   const handlePitchedClick = () => {
//     setPitchedOpen(!pitchedOpen);
//     if (companyOpen) {
//       setCompanyOpen(false);
//     }

//     if (clientOpen) {
//       setClientOpen(false);
//     }
//     if (userOpen) {
//       setUserOpen(false);
//     }
//     if (leadOpen) {
//       setLeadOpen(false);
//     }
//   };

//   const handleDemoClick = () => {
//     setDemoOpen(!demoOpen);

//     if (companyOpen) {
//       setCompanyOpen(false);
//     }
//     if (clientOpen) {
//       setClientOpen(false);
//     }
//     if (userOpen) {
//       setUserOpen(false);
//     }
//     if (leadOpen) {
//       setLeadOpen(false);
//     }
//     if (pitchedOpen) {
//       setPitchedOpen(false);
//     }
//   };
//   const handleNegotiationsClick = () => {
//     setNegotiationsOpen(!negotiationsOpen);
//     // Close other sub-menus if open
//     if (companyOpen) {
//       setCompanyOpen(false);
//     }
//     if (clientOpen) {
//       setClientOpen(false);
//     }
//     if (userOpen) {
//       setUserOpen(false);
//     }
//     if (leadOpen) {
//       setLeadOpen(false);
//     }
//     if (pitchedOpen) {
//       setPitchedOpen(false);
//     }
//     if (demoOpen) {
//       setDemoOpen(false);
//     }
//   };
//   const handleClosedLostClick = () => {
//     setClosedLostOpen(!closedLostOpen);
//     // Close other sub-menus if open

//     if (companyOpen) {
//       setCompanyOpen(false);
//     }
//     if (clientOpen) {
//       setClientOpen(false);
//     }
//     if (userOpen) {
//       setUserOpen(false);
//     }
//     if (leadOpen) {
//       setLeadOpen(false);
//     }
//     if (pitchedOpen) {
//       setPitchedOpen(false);
//     }
//     if (demoOpen) {
//       setDemoOpen(false);
//     }
//     if (negotiationsOpen) {
//       setNegotiationsOpen(false);
//     }
//   };
//   const handleClosedWonClick = () => {
//     setClosedWonOpen(!closedWonOpen);
//     // Close other sub-menus if open
//     if (clientOpen) {
//       setClientOpen(false);
//     }
//     if (companyOpen) {
//       setCompanyOpen(false);
//     }
//     if (userOpen) {
//       setUserOpen(false);
//     }
//     if (leadOpen) {
//       setLeadOpen(false);
//     }
//     if (pitchedOpen) {
//       setPitchedOpen(false);
//     }
//     if (demoOpen) {
//       setDemoOpen(false);
//     }
//     if (negotiationsOpen) {
//       setNegotiationsOpen(false);
//     }
//     if (closedLostOpen) {
//       setClosedLostOpen(false);
//     }
//   };

//   const handleRnRClick = () => {
//     setRnROpen(!rnrOpen);
//     // Close other sub-menus if open
//     if (companyOpen) {
//       setCompanyOpen(false);
//     }
//     if (clientOpen) {
//       setClientOpen(false);
//     }
//     if (userOpen) {
//       setUserOpen(false);
//     }
//     if (leadOpen) {
//       setLeadOpen(false);
//     }
//     if (pitchedOpen) {
//       setPitchedOpen(false);
//     }
//     if (demoOpen) {
//       setDemoOpen(false);
//     }
//     if (negotiationsOpen) {
//       setNegotiationsOpen(false);
//     }
//     if (closedLostOpen) {
//       setClosedLostOpen(false);
//     }
//     if (closedWonOpen) {
//       setClosedWonOpen(false);
//     }
//   };

//   const handleJunkClick = () => {
//     setJunkOpen(!junkOpen);
//     // Close other sub-menus if open
//     if (companyOpen) {
//       setCompanyOpen(false);
//     }
//     if (clientOpen) {
//       setClientOpen(false);
//     }
//     if (userOpen) {
//       setUserOpen(false);
//     }
//     if (leadOpen) {
//       setLeadOpen(false);
//     }
//     if (pitchedOpen) {
//       setPitchedOpen(false);
//     }
//     if (demoOpen) {
//       setDemoOpen(false);
//     }
//     if (negotiationsOpen) {
//       setNegotiationsOpen(false);
//     }
//     if (closedLostOpen) {
//       setClosedLostOpen(false);
//     }
//     if (closedWonOpen) {
//       setClosedWonOpen(false);
//     }
//     if (rnrOpen) {
//       setRnROpen(false);
//     }
//   };

//   const handleCompanyClick = () => {
//     setCompanyOpen(!companyOpen);
//     // Close other sub-menus if open
//     if (junkOpen) {
//       setJunkOpen(false);
//     }
//     if (clientOpen) {
//       setClientOpen(false);
//     }
//     if (userOpen) {
//       setUserOpen(false);
//     }
//     if (leadOpen) {
//       setLeadOpen(false);
//     }
//     if (pitchedOpen) {
//       setPitchedOpen(false);
//     }
//     if (demoOpen) {
//       setDemoOpen(false);
//     }
//     if (negotiationsOpen) {
//       setNegotiationsOpen(false);
//     }
//     if (closedLostOpen) {
//       setClosedLostOpen(false);
//     }
//     if (closedWonOpen) {
//       setClosedWonOpen(false);
//     }
//     if (rnrOpen) {
//       setRnROpen(false);
//     }
//   };

//   const handleDashboardClick = () => {
//     closeAllSubMenus();
//     // Add specific logic related to the Dashboard click if needed
//   };

//   return (
//     <>
//       <Helmet>
//         <title>ContactTab - Dashboard</title>
//       </Helmet>
//       <Box sx={{ display: "flex" }}>
//         <CssBaseline />
//         <AppBar
//           position="fixed"
//           open={open}
//         >
//           <Toolbar>
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               onClick={handleDrawerOpen}
//               edge="start"
//               sx={{
//                 marginRight: 5,
//                 ...(open && { display: "none" }),
//               }}
//             >
//               <MenuIcon />
//             </IconButton>
//             <Typography
//               variant="h6"
//               noWrap
//               component="div"
//             >
//               Mini variant drawer
//             </Typography>
//           </Toolbar>
//         </AppBar>
//         <Drawer
//           variant="permanent"
//           open={open}
//         >
//           <DrawerHeader>
//             <img
//               src={Contacttablog}
//               alt="Contact Tab Logo"
//               style={{ height: "100%", widt: "100%" }}
//             />
//             <IconButton onClick={handleDrawerClose}>
//               {theme.direction === "rtl" ? (
//                 <ChevronRightIcon />
//               ) : (
//                 <ChevronLeftIcon />
//               )}
//             </IconButton>
//           </DrawerHeader>
//           <Divider />

//           <List>
//             {[
//               "Dashboard",
//               "Estabalishment",
//               "Leads",
//               "Users",
//               "Clients",
//               "Pitched",
//               "Demo",
//               "Negotiations",
//               "Closed Lost",
//               "Closed Won",
//               "RNR",
//               "Junk",
//             ].map((text, index) => (
//               <React.Fragment key={text}>
//                 {text === "Dashboard" ? (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <Link to="">
//                       <ListItemButton
//                         onClick={handleDashboardClick}
//                         sx={{
//                           minHeight: 48,
//                           justifyContent: open ? "initial" : "center",
//                           px: 2.5,
//                         }}
//                       >
//                         <ListItemIcon
//                           sx={{
//                             minWidth: 0,
//                             mr: open ? 3 : "auto",
//                             justifyContent: "center",
//                           }}
//                         >
//                           {index % 2 === 0 ? <DashboardIcon /> : <MailIcon />}
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={text}
//                           sx={{ opacity: open ? 1 : 0 }}
//                         />
//                       </ListItemButton>
//                     </Link>
//                   </ListItem>
//                 ) : text === "Estabalishment" ? (
//                   <React.Fragment>
//                     <ListItem
//                       disablePadding
//                       sx={{ display: "block" }}
//                     >
//                       <ListItemButton
//                         onClick={handleCompanyClick}
//                         sx={{
//                           minHeight: 48,
//                           justifyContent: open ? "initial" : "center",
//                           px: 2.5,
//                         }}
//                       >
//                         <ListItemIcon
//                           sx={{
//                             minWidth: 0,
//                             mr: open ? 3 : "auto",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <FaceIcon />
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={text}
//                           sx={{ opacity: open ? 1 : 0 }}
//                         />
//                       </ListItemButton>
//                     </ListItem>
//                     {companyOpen && (
//                       <List sx={{ paddingLeft: open ? 2 : 0 }}>
//                         <Link to="company-add">
//                           <ListItem
//                             disablePadding
//                             sx={{ display: "block" }}
//                           >
//                             <ListItemButton
//                               sx={{
//                                 minHeight: 48,
//                                 justifyContent: open ? "initial" : "center",
//                                 px: 4,
//                               }}
//                             >
//                               <ListItemIcon
//                                 sx={{
//                                   minWidth: 0,
//                                   mr: open ? 3 : "auto",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <InboxIcon />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary="Add Estabalishment"
//                                 sx={{ opacity: open ? 1 : 0 }}
//                               />
//                             </ListItemButton>
//                           </ListItem>
//                         </Link>
//                         <Link to="company-list">
//                           <ListItem
//                             disablePadding
//                             sx={{ display: "block" }}
//                           >
//                             <ListItemButton
//                               sx={{
//                                 minHeight: 48,
//                                 justifyContent: open ? "initial" : "center",
//                                 px: 4,
//                               }}
//                             >
//                               <ListItemIcon
//                                 sx={{
//                                   minWidth: 0,
//                                   mr: open ? 3 : "auto",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <InboxIcon />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary="All Estabalishment"
//                                 sx={{ opacity: open ? 1 : 0 }}
//                               />
//                             </ListItemButton>
//                           </ListItem>
//                         </Link>
//                       </List>
//                     )}
//                   </React.Fragment>
//                 ) : text === "Clients" ? (
//                   <React.Fragment>
//                     <ListItem
//                       disablePadding
//                       sx={{ display: "block" }}
//                     >
//                       <ListItemButton
//                         onClick={handleClientClick}
//                         sx={{
//                           minHeight: 48,
//                           justifyContent: open ? "initial" : "center",
//                           px: 2.5,
//                         }}
//                       >
//                         <ListItemIcon
//                           sx={{
//                             minWidth: 0,
//                             mr: open ? 3 : "auto",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <FaceIcon />
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={text}
//                           sx={{ opacity: open ? 1 : 0 }}
//                         />
//                       </ListItemButton>
//                     </ListItem>
//                     {clientOpen && (
//                       <List sx={{ paddingLeft: open ? 2 : 0 }}>
//                         <Link to="client-registration">
//                           <ListItem
//                             disablePadding
//                             sx={{ display: "block" }}
//                           >
//                             <ListItemButton
//                               sx={{
//                                 minHeight: 48,
//                                 justifyContent: open ? "initial" : "center",
//                                 px: 4,
//                               }}
//                             >
//                               <ListItemIcon
//                                 sx={{
//                                   minWidth: 0,
//                                   mr: open ? 3 : "auto",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <InboxIcon />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary="Add Clients"
//                                 sx={{ opacity: open ? 1 : 0 }}
//                               />
//                             </ListItemButton>
//                           </ListItem>
//                         </Link>
//                         <Link to="client-list">
//                           <ListItem
//                             disablePadding
//                             sx={{ display: "block" }}
//                           >
//                             <ListItemButton
//                               sx={{
//                                 minHeight: 48,
//                                 justifyContent: open ? "initial" : "center",
//                                 px: 4,
//                               }}
//                             >
//                               <ListItemIcon
//                                 sx={{
//                                   minWidth: 0,
//                                   mr: open ? 3 : "auto",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <InboxIcon />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary="All Clients"
//                                 sx={{ opacity: open ? 1 : 0 }}
//                               />
//                             </ListItemButton>
//                           </ListItem>
//                         </Link>
//                       </List>
//                     )}
//                   </React.Fragment>
//                 ) : text === "Users" ? (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <ListItemButton
//                       onClick={handleUserClick}
//                       sx={{
//                         minHeight: 48,
//                         justifyContent: open ? "initial" : "center",
//                         px: 2.5,
//                       }}
//                     >
//                       <ListItemIcon
//                         sx={{
//                           minWidth: 0,
//                           mr: open ? 3 : "auto",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {index % 2 === 0 ? (
//                           <SupervisedUserCircleIcon />
//                         ) : (
//                           <MailIcon />
//                         )}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={text}
//                         sx={{ opacity: open ? 1 : 0 }}
//                       />
//                     </ListItemButton>
//                     {userOpen && (
//                       <List sx={{ paddingLeft: open ? 2 : 0 }}>
//                         <Link to="Employee-Registration">
//                           <ListItem
//                             disablePadding
//                             sx={{ display: "block" }}
//                           >
//                             <ListItemButton
//                               sx={{
//                                 minHeight: 48,
//                                 justifyContent: open ? "initial" : "center",
//                                 px: 4,
//                               }}
//                             >
//                               <ListItemIcon
//                                 sx={{
//                                   minWidth: 0,
//                                   mr: open ? 3 : "auto",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <InboxIcon />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary="Add Users"
//                                 sx={{ opacity: open ? 1 : 0 }}
//                               />
//                             </ListItemButton>
//                           </ListItem>
//                         </Link>
//                         <Link to="EmployeeList">
//                           <ListItem
//                             disablePadding
//                             sx={{ display: "block" }}
//                           >
//                             <ListItemButton
//                               sx={{
//                                 minHeight: 48,
//                                 justifyContent: open ? "initial" : "center",
//                                 px: 4,
//                               }}
//                             >
//                               <ListItemIcon
//                                 sx={{
//                                   minWidth: 0,
//                                   mr: open ? 3 : "auto",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <InboxIcon />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary="All Users"
//                                 sx={{ opacity: open ? 1 : 0 }}
//                               />
//                             </ListItemButton>
//                           </ListItem>
//                         </Link>
//                       </List>
//                     )}
//                   </ListItem>
//                 ) : text === "Leads" ? (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <ListItemButton
//                       onClick={handleLeadClick}
//                       sx={{
//                         minHeight: 48,
//                         justifyContent: open ? "initial" : "center",
//                         px: 2.5,
//                       }}
//                     >
//                       <ListItemIcon
//                         sx={{
//                           minWidth: 0,
//                           mr: open ? 3 : "auto",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {index % 2 === 0 ? <GroupsIcon /> : <GroupsIcon />}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={text}
//                         sx={{ opacity: open ? 1 : 0 }}
//                       />
//                     </ListItemButton>
//                     {leadOpen && (
//                       <List sx={{ paddingLeft: open ? 2 : 0 }}>
//                         <ListItem
//                           disablePadding
//                           sx={{ display: "block" }}
//                         >
//                           <Link to="Add-lead">
//                             <ListItemButton
//                               sx={{
//                                 minHeight: 48,
//                                 justifyContent: open ? "initial" : "center",
//                                 px: 4,
//                               }}
//                             >
//                               <ListItemIcon
//                                 sx={{
//                                   minWidth: 0,
//                                   mr: open ? 3 : "auto",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <InboxIcon />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary="Add Lead"
//                                 sx={{ opacity: open ? 1 : 0 }}
//                               />
//                             </ListItemButton>
//                           </Link>
//                         </ListItem>
//                         <ListItem
//                           disablePadding
//                           sx={{ display: "block" }}
//                         >
//                           <Link to="Lead-List">
//                             <ListItemButton
//                               sx={{
//                                 minHeight: 48,
//                                 justifyContent: open ? "initial" : "center",
//                                 px: 4,
//                               }}
//                             >
//                               <ListItemIcon
//                                 sx={{
//                                   minWidth: 0,
//                                   mr: open ? 3 : "auto",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <InboxIcon />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary="All Lead"
//                                 sx={{ opacity: open ? 1 : 0 }}
//                               />
//                             </ListItemButton>
//                           </Link>
//                         </ListItem>
//                       </List>
//                     )}
//                   </ListItem>
//                 ) : text === "Pitched" ? (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <ListItemButton
//                       onClick={handlePitchedClick}
//                       sx={{
//                         minHeight: 48,
//                         justifyContent: open ? "initial" : "center",
//                         px: 2.5,
//                       }}
//                     >
//                       <ListItemIcon
//                         sx={{
//                           minWidth: 0,
//                           mr: open ? 3 : "auto",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <CallEndIcon />{" "}
//                         {/* Use FlightTakeoffIcon for Pitched */}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={text}
//                         sx={{ opacity: open ? 1 : 0 }}
//                       />
//                     </ListItemButton>

//                     {pitchedOpen && (
//                       <List sx={{ paddingLeft: open ? 2 : 0 }}>
//                         <ListItem
//                           disablePadding
//                           sx={{ display: "block" }}
//                         >
//                           <Link to="pitched-add">
//                             <ListItemButton
//                               sx={{
//                                 minHeight: 48,
//                                 justifyContent: open ? "initial" : "center",
//                                 px: 4,
//                               }}
//                             >
//                               <ListItemIcon
//                                 sx={{
//                                   minWidth: 0,
//                                   mr: open ? 3 : "auto",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <InboxIcon />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary="Add Pitched"
//                                 sx={{ opacity: open ? 1 : 0 }}
//                               />
//                             </ListItemButton>
//                           </Link>
//                         </ListItem>
//                         <ListItem
//                           disablePadding
//                           sx={{ display: "block" }}
//                         >
//                           <Link to="pitched-list">
//                             <ListItemButton
//                               sx={{
//                                 minHeight: 48,
//                                 justifyContent: open ? "initial" : "center",
//                                 px: 4,
//                               }}
//                             >
//                               <ListItemIcon
//                                 sx={{
//                                   minWidth: 0,
//                                   mr: open ? 3 : "auto",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <InboxIcon />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary="All Pitched"
//                                 sx={{ opacity: open ? 1 : 0 }}
//                               />
//                             </ListItemButton>
//                           </Link>
//                         </ListItem>
//                       </List>
//                     )}
//                   </ListItem>
//                 ) : text === "Demo" ? (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <ListItemButton
//                       onClick={handleDemoClick}
//                       sx={{
//                         minHeight: 48,
//                         justifyContent: open ? "initial" : "center",
//                         px: 2.5,
//                       }}
//                     >
//                       <ListItemIcon
//                         sx={{
//                           minWidth: 0,
//                           mr: open ? 3 : "auto",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={text}
//                         sx={{ opacity: open ? 1 : 0 }}
//                       />
//                     </ListItemButton>
//                   </ListItem>
//                 ) : text === "Negotiations" ? (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <ListItemButton
//                       onClick={handleNegotiationsClick}
//                       sx={{
//                         minHeight: 48,
//                         justifyContent: open ? "initial" : "center",
//                         px: 2.5,
//                       }}
//                     >
//                       <ListItemIcon
//                         sx={{
//                           minWidth: 0,
//                           mr: open ? 3 : "auto",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={text}
//                         sx={{ opacity: open ? 1 : 0 }}
//                       />
//                     </ListItemButton>
//                   </ListItem>
//                 ) : text === "Closed Lost" ? (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <ListItemButton
//                       onClick={handleClosedLostClick}
//                       sx={{
//                         minHeight: 48,
//                         justifyContent: open ? "initial" : "center",
//                         px: 2.5,
//                       }}
//                     >
//                       <ListItemIcon
//                         sx={{
//                           minWidth: 0,
//                           mr: open ? 3 : "auto",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={text}
//                         sx={{ opacity: open ? 1 : 0 }}
//                       />
//                     </ListItemButton>
//                   </ListItem>
//                 ) : text === "Closed Won" ? (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <ListItemButton
//                       onClick={handleClosedWonClick}
//                       sx={{
//                         minHeight: 48,
//                         justifyContent: open ? "initial" : "center",
//                         px: 2.5,
//                       }}
//                     >
//                       <ListItemIcon
//                         sx={{
//                           minWidth: 0,
//                           mr: open ? 3 : "auto",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={text}
//                         sx={{ opacity: open ? 1 : 0 }}
//                       />
//                     </ListItemButton>
//                   </ListItem>
//                 ) : text === "RNR" ? (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <ListItemButton
//                       onClick={handleRnRClick}
//                       sx={{
//                         minHeight: 48,
//                         justifyContent: open ? "initial" : "center",
//                         px: 2.5,
//                       }}
//                     >
//                       <ListItemIcon
//                         sx={{
//                           minWidth: 0,
//                           mr: open ? 3 : "auto",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={text}
//                         sx={{ opacity: open ? 1 : 0 }}
//                       />
//                     </ListItemButton>
//                   </ListItem>
//                 ) : text === "Junk" ? (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <ListItemButton
//                       onClick={handleJunkClick}
//                       sx={{
//                         minHeight: 48,
//                         justifyContent: open ? "initial" : "center",
//                         px: 2.5,
//                       }}
//                     >
//                       <ListItemIcon
//                         sx={{
//                           minWidth: 0,
//                           mr: open ? 3 : "auto",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={text}
//                         sx={{ opacity: open ? 1 : 0 }}
//                       />
//                     </ListItemButton>
//                   </ListItem>
//                 ) : (
//                   <ListItem
//                     disablePadding
//                     sx={{ display: "block" }}
//                   >
//                     <ListItemButton
//                       sx={{
//                         minHeight: 48,
//                         justifyContent: open ? "initial" : "center",
//                         px: 2.5,
//                       }}
//                     >
//                       <ListItemIcon
//                         sx={{
//                           minWidth: 0,
//                           mr: open ? 3 : "auto",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={text}
//                         sx={{ opacity: open ? 1 : 0 }}
//                       />
//                     </ListItemButton>
//                   </ListItem>
//                 )}
//               </React.Fragment>
//             ))}
//           </List>
//         </Drawer>
//         <Box
//           component="main"
//           sx={{ flexGrow: 1, p: 3 }}
//         >
//           <DrawerHeader />
//           <Outlet />
//         </Box>
//       </Box>
//     </>
//   );
// }

import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import DashboardIcon from "@mui/icons-material/Dashboard";
// import GroupsIcon from "@mui/icons-material/Groups";
import GroupsIcon from "@mui/icons-material/Groups";

import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import FaceIcon from "@mui/icons-material/Face";
import CallEndIcon from "@mui/icons-material/CallEnd";
import Contacttabblog from "../../Assets/img/logoside.svg";
import { Link, Outlet } from "react-router-dom";
import { Helmet } from "react-helmet";
import Dashboard from "../Dashboard/Dashboard.css";
import axiosInstance from "../../Axios/axiosInstance";
// import axios from "axios"; // Import axios
import { useNavigate } from "react-router-dom";
// import { useHistory } from "react-router-dom";

//new
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import Person3Icon from "@mui/icons-material/Person3";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DvrIcon from "@mui/icons-material/Dvr";
import HandshakeIcon from "@mui/icons-material/Handshake";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";
import AutoDeleteIcon from "@mui/icons-material/AutoDelete";
import Container from "@mui/material/Container";

import {
  Button, // Make sure Button is imported from @mui/material
} from "@mui/material";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: "calc(${theme.spacing(7)} + 1px)",
  [theme.breakpoints.up("sm")]: {
    width: "calc(${theme.spacing(8)} + 1px)",
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: "calc(100% - ${drawerWidth}px)",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const StyledDrawer = styled(Drawer)(({ theme, open }) => ({
  width: "240px", // You can adjust the width as needed
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: "240px",
    boxSizing: "border-box",
    backgroundColor: "#000000", // Set your desired background color
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}));

export default function Sidenav() {
  const theme = useTheme();
  // const history = useHistory();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);
  const [companyOpen, setCompanyOpen] = React.useState(false);
  const [clientOpen, setClientOpen] = React.useState(false); // State for Client sub-menu
  const [userOpen, setUserOpen] = React.useState(false); // State for User sub-menu
  const [leadOpen, setLeadOpen] = React.useState(false); // State for Leads sub-menu
  const [pitchedOpen, setPitchedOpen] = React.useState(false);
  const [demoOpen, setDemoOpen] = React.useState(false);
  const [negotiationsOpen, setNegotiationsOpen] = React.useState(false);
  const [closedLostOpen, setClosedLostOpen] = React.useState(false);
  const [closedWonOpen, setClosedWonOpen] = React.useState(false);
  const [rnrOpen, setRnROpen] = React.useState(false);
  const [junkOpen, setJunkOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const closeAllSubMenus = () => {
    setClientOpen(false);
    setUserOpen(false);
    setLeadOpen(false);
    setCompanyOpen(false);
    setPitchedOpen(false);
    // Closing the Leads sub-menu
    // Add more logic here if more sub-menus are present
  };

  const handleClientClick = () => {
    setClientOpen(!clientOpen);

    if (companyOpen) {
      setCompanyOpen(false);
    }
    if (userOpen) {
      setUserOpen(false);
    }
    if (leadOpen) {
      setLeadOpen(false);
    }
    if (pitchedOpen) {
      setPitchedOpen(false);
    }
  };

  const handleUserClick = () => {
    setUserOpen(!userOpen);
    if (companyOpen) {
      setCompanyOpen(false);
    }
    if (clientOpen) {
      setClientOpen(false);
    }
    if (leadOpen) {
      setLeadOpen(false);
    }
    if (pitchedOpen) {
      setPitchedOpen(false);
    }
  };

  const handleLeadClick = () => {
    setLeadOpen(!leadOpen);

    if (companyOpen) {
      setCompanyOpen(false);
    }
    if (clientOpen) {
      setClientOpen(false);
    }
    if (userOpen) {
      setUserOpen(false);
    }
    if (pitchedOpen) {
      setPitchedOpen(false);
    }
  };

  const handlePitchedClick = () => {
    setPitchedOpen(!pitchedOpen);
    if (companyOpen) {
      setCompanyOpen(false);
    }

    if (clientOpen) {
      setClientOpen(false);
    }
    if (userOpen) {
      setUserOpen(false);
    }
    if (leadOpen) {
      setLeadOpen(false);
    }
  };

  const handleDemoClick = () => {
    setDemoOpen(!demoOpen);

    if (companyOpen) {
      setCompanyOpen(false);
    }
    if (clientOpen) {
      setClientOpen(false);
    }
    if (userOpen) {
      setUserOpen(false);
    }
    if (leadOpen) {
      setLeadOpen(false);
    }
    if (pitchedOpen) {
      setPitchedOpen(false);
    }
  };
  const handleNegotiationsClick = () => {
    setNegotiationsOpen(!negotiationsOpen);
    // Close other sub-menus if open
    if (companyOpen) {
      setCompanyOpen(false);
    }
    if (clientOpen) {
      setClientOpen(false);
    }
    if (userOpen) {
      setUserOpen(false);
    }
    if (leadOpen) {
      setLeadOpen(false);
    }
    if (pitchedOpen) {
      setPitchedOpen(false);
    }
    if (demoOpen) {
      setDemoOpen(false);
    }
  };
  const handleClosedLostClick = () => {
    setClosedLostOpen(!closedLostOpen);
    // Close other sub-menus if open

    if (companyOpen) {
      setCompanyOpen(false);
    }
    if (clientOpen) {
      setClientOpen(false);
    }
    if (userOpen) {
      setUserOpen(false);
    }
    if (leadOpen) {
      setLeadOpen(false);
    }
    if (pitchedOpen) {
      setPitchedOpen(false);
    }
    if (demoOpen) {
      setDemoOpen(false);
    }
    if (negotiationsOpen) {
      setNegotiationsOpen(false);
    }
  };
  const handleClosedWonClick = () => {
    setClosedWonOpen(!closedWonOpen);
    // Close other sub-menus if open
    if (clientOpen) {
      setClientOpen(false);
    }
    if (companyOpen) {
      setCompanyOpen(false);
    }
    if (userOpen) {
      setUserOpen(false);
    }
    if (leadOpen) {
      setLeadOpen(false);
    }
    if (pitchedOpen) {
      setPitchedOpen(false);
    }
    if (demoOpen) {
      setDemoOpen(false);
    }
    if (negotiationsOpen) {
      setNegotiationsOpen(false);
    }
    if (closedLostOpen) {
      setClosedLostOpen(false);
    }
  };

  const handleRnRClick = () => {
    setRnROpen(!rnrOpen);
    // Close other sub-menus if open
    if (companyOpen) {
      setCompanyOpen(false);
    }
    if (clientOpen) {
      setClientOpen(false);
    }
    if (userOpen) {
      setUserOpen(false);
    }
    if (leadOpen) {
      setLeadOpen(false);
    }
    if (pitchedOpen) {
      setPitchedOpen(false);
    }
    if (demoOpen) {
      setDemoOpen(false);
    }
    if (negotiationsOpen) {
      setNegotiationsOpen(false);
    }
    if (closedLostOpen) {
      setClosedLostOpen(false);
    }
    if (closedWonOpen) {
      setClosedWonOpen(false);
    }
  };

  const handleJunkClick = () => {
    setJunkOpen(!junkOpen);
    // Close other sub-menus if open
    if (companyOpen) {
      setCompanyOpen(false);
    }
    if (clientOpen) {
      setClientOpen(false);
    }
    if (userOpen) {
      setUserOpen(false);
    }
    if (leadOpen) {
      setLeadOpen(false);
    }
    if (pitchedOpen) {
      setPitchedOpen(false);
    }
    if (demoOpen) {
      setDemoOpen(false);
    }
    if (negotiationsOpen) {
      setNegotiationsOpen(false);
    }
    if (closedLostOpen) {
      setClosedLostOpen(false);
    }
    if (closedWonOpen) {
      setClosedWonOpen(false);
    }
    if (rnrOpen) {
      setRnROpen(false);
    }
  };

  const handleCompanyClick = () => {
    setCompanyOpen(!companyOpen);
    // Close other sub-menus if open
    if (junkOpen) {
      setJunkOpen(false);
    }
    if (clientOpen) {
      setClientOpen(false);
    }
    if (userOpen) {
      setUserOpen(false);
    }
    if (leadOpen) {
      setLeadOpen(false);
    }
    if (pitchedOpen) {
      setPitchedOpen(false);
    }
    if (demoOpen) {
      setDemoOpen(false);
    }
    if (negotiationsOpen) {
      setNegotiationsOpen(false);
    }
    if (closedLostOpen) {
      setClosedLostOpen(false);
    }
    if (closedWonOpen) {
      setClosedWonOpen(false);
    }
    if (rnrOpen) {
      setRnROpen(false);
    }
  };

  const handleDashboardClick = () => {
    closeAllSubMenus();
    // Add specific logic related to the Dashboard click if needed
  };

  const handleLogout = async () => {
    try {
      // Call the server-side logout endpoint
      await axiosInstance.post("/api/logout");

      // Remove the token from session storage
      sessionStorage.removeItem("jwtToken");

      // Redirect to the login page or any other desired route
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      // Handle logout failure if needed
    }
  };

  return (
    <>
      <Helmet>
        <title>
          ContactTab - Discover the ease of customer relationship management
          with ContactTab's powerful CRM solutions. Simplify lead generation,
          enhance communication, and boost productivity seamlessly. From initial
          contact to post-sale support, our user-friendly CRM platform empowers
          you to build and maintain lasting connections effortlessly. Choose
          ContactTab for efficient and scalable growth
        </title>
      </Helmet>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="fixed" open={open}>
          <Container maxWidth="xl">
            <Toolbar 
            disableGutters
            style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Typography variant="h6" color="inherit" component="div">
                <img height="50rem" width="150rem" src={Contacttabblog} />
              </Typography>

              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{
                  marginRight: 5,
                  ...(open && { display: "none" }),
                }}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap component="div">
                {/* Mini variant drawer */}
                <Button
                  color="inherit"
                  onClick={handleLogout}
                  style={{ marginLeft: "70em" }}
                  // style={{ display: "flex", float: "right" }}
                >
                  Logout
                </Button>
              </Typography>
            </Toolbar>

            {/* <Toolbar>
              
            </Toolbar> */}
          </Container>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <DrawerHeader>
            {/* <img
              src={Contacttabblog}
              alt="Contact Tab Logo"
              style={{ height: "100%", width: "100%" }}
            /> */}
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Drawer />

          <List style={{ backgroundColor: "#0E377D" }}>
            {[
              "Dashboard",
              "Estabalishment",
              "Leads",
              "Users",
              "Clients",
              "Pitched",
              "Demo",
              "Negotiations",
              "Closed Lost",
              "Closed Won",
              "RNR",
              "Junk",
            ].map((text, index) => (
              <React.Fragment key={text}>
                {text === "Dashboard" ? (
                  <ListItem
                    disablePadding
                    sx={{
                      display: "block",
                      textDecoration:
                        text === "Dashboard" ? "none" : "underline",
                      "&:hover": {
                        textDecoration:
                          text === "Dashboard" ? "none" : "underline",
                      },
                    }}
                  >
                    <Link to="">
                      <ListItemButton
                        onClick={handleDashboardClick}
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          {index % 2 === 0 ? <DashboardIcon /> : <MailIcon />}
                        </ListItemIcon>
                        <ListItemText
                          primary={text}
                          sx={{ opacity: open ? 1 : 0 }}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                ) : text === "Estabalishment" ? (
                  <React.Fragment>
                    <ListItem disablePadding sx={{ display: "block" }}>
                      <ListItemButton
                        onClick={handleCompanyClick}
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <FaceIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={text}
                          sx={{ opacity: open ? 1 : 0 }}
                        />
                      </ListItemButton>
                    </ListItem>
                    {companyOpen && (
                      <List sx={{ paddingLeft: open ? 2 : 0 }}>
                        <Link to="company-add">
                          <ListItem
                            disablePadding
                            sx={{ display: "block", textDecoration: "none" }}
                          >
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 4,
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary="Add Estabalishment"
                                sx={{ opacity: open ? 1 : 0 }}
                              />
                            </ListItemButton>
                          </ListItem>
                        </Link>
                        <Link to="company-list">
                          <ListItem disablePadding sx={{ display: "block" }}>
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 4,
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary="All Estabalishment"
                                sx={{ opacity: open ? 1 : 0 }}
                              />
                            </ListItemButton>
                          </ListItem>
                        </Link>
                      </List>
                    )}
                  </React.Fragment>
                ) : text === "Clients" ? (
                  <React.Fragment>
                    <ListItem disablePadding sx={{ display: "block" }}>
                      <ListItemButton
                        onClick={handleClientClick}
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <FaceIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={text}
                          sx={{ opacity: open ? 1 : 0 }}
                        />
                      </ListItemButton>
                    </ListItem>
                    {clientOpen && (
                      <List sx={{ paddingLeft: open ? 2 : 0 }}>
                        <Link to="client-registration">
                          <ListItem disablePadding sx={{ display: "block" }}>
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 4,
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary="Add Clients"
                                sx={{ opacity: open ? 1 : 0 }}
                              />
                            </ListItemButton>
                          </ListItem>
                        </Link>
                        <Link to="client-list">
                          <ListItem disablePadding sx={{ display: "block" }}>
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 4,
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary="All Clients"
                                sx={{ opacity: open ? 1 : 0 }}
                              />
                            </ListItemButton>
                          </ListItem>
                        </Link>
                      </List>
                    )}
                  </React.Fragment>
                ) : text === "Users" ? (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      onClick={handleUserClick}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {index % 2 === 0 ? (
                          <SupervisedUserCircleIcon />
                        ) : (
                          <MailIcon />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                    {userOpen && (
                      <List sx={{ paddingLeft: open ? 2 : 0 }}>
                        <Link to="Employee-Registration">
                          <ListItem disablePadding sx={{ display: "block" }}>
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 4,
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary="Add Users"
                                sx={{ opacity: open ? 1 : 0 }}
                              />
                            </ListItemButton>
                          </ListItem>
                        </Link>
                        <Link to="EmployeeList">
                          <ListItem disablePadding sx={{ display: "block" }}>
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 4,
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary="All Users"
                                sx={{ opacity: open ? 1 : 0 }}
                              />
                            </ListItemButton>
                          </ListItem>
                        </Link>
                      </List>
                    )}
                  </ListItem>
                ) : text === "Leads" ? (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      onClick={handleLeadClick}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {index % 2 === 0 ? <GroupsIcon /> : <GroupsIcon />}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                    {leadOpen && (
                      <List sx={{ paddingLeft: open ? 2 : 0 }}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                          <Link
                            to="Add-lead"
                            style={{ textDecoration: "none", color: "#000" }}
                          >
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 4,
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary="Add Lead"
                                sx={{ opacity: open ? 1 : 0 }}
                              />
                            </ListItemButton>
                          </Link>
                        </ListItem>
                        <ListItem disablePadding sx={{ display: "block" }}>
                          <Link
                            to="Lead-List"
                            style={{ textDecoration: "none", color: "#000" }}
                          >
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 4,
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary="All Lead"
                                sx={{ opacity: open ? 1 : 0 }}
                              />
                            </ListItemButton>
                          </Link>
                        </ListItem>
                      </List>
                    )}
                  </ListItem>
                ) : text === "Pitched" ? (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      onClick={handlePitchedClick}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        <CallEndIcon />{" "}
                        {/* Use FlightTakeoffIcon for Pitched */}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>

                    {pitchedOpen && (
                      <List sx={{ paddingLeft: open ? 2 : 0 }}>
                        {/* <ListItem disablePadding sx={{ display: "block" }}>
                          <Link to="pitched-add">
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 4,
                              }}
                            ></ListItemButton>
                          </Link>
                        </ListItem> */}
                        <ListItem disablePadding sx={{ display: "block" }}>
                          <Link to="pitched-list">
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 4,
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <InboxIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary="All Pitched"
                                sx={{ opacity: open ? 1 : 0 }}
                              />
                            </ListItemButton>
                          </Link>
                        </ListItem>
                      </List>
                    )}
                  </ListItem>
                ) : text === "Demo" ? (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      onClick={handleDemoClick}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                ) : text === "Negotiations" ? (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      onClick={handleNegotiationsClick}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                ) : text === "Closed Lost" ? (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      onClick={handleClosedLostClick}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                ) : text === "Closed Won" ? (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      onClick={handleClosedWonClick}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                ) : text === "RNR" ? (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      onClick={handleRnRClick}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                ) : text === "Junk" ? (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      onClick={handleJunkClick}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                ) : (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                      </ListItemIcon>
                      <ListItemText
                        primary={text}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                )}
              </React.Fragment>
            ))}
          </List>
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />
          <Outlet />
        </Box>
      </Box>
    </>
  );
}
